import { baseConfig } from './base.config';
import { Config } from './config.interface';

export const developConfig: Config = {
  ...baseConfig,
  blockchain: {
    providers: {
      tenderly: {
        url: 'https://polygon.gateway.tenderly.co/4oFjumHRdk1NeYZFKTOf2T',
        wss: 'wss://polygon.gateway.tenderly.co/4oFjumHRdk1NeYZFKTOf2T',
      },
      quickNode: {
        url: 'https://red-fittest-gas.matic.quiknode.pro/68c40bd882ebc3a99ef23cc10a38e50826cef24a',
        wss: 'wss://red-fittest-gas.matic.quiknode.pro/68c40bd882ebc3a99ef23cc10a38e50826cef24a',
      },
    },
    explorerUrl: 'https://polygonscan.com',
    chainId: 137,
    usdtDecimals: 18,
    phnmDecimals: 18,
  },
  posthogPublicApiKey: 'phc_BJuZLS9RyWv2BWm5ltPfe0dweOaBqnPhVYWLAUavm0X',
  tenderly: {
    accountSlug: 'phenom_poker',
    projectSlug: 'backend-dev',
  },
  urls: {
    app: 'https://app.dev.phenompoker.com',
    admin: 'https://admin.dev.phenompoker.com',
    landing: 'https://phenompoker.com',
    otherCorsOrigins: ['http://localhost:3000'],
    desktopClientDownloadPrefix: 'https://assets.dev.phenompoker.com/desktop-client/Phenom%20Poker.dev',
  },
};
